<template>
	<div class="row footer-block">
		<div class="col-12 col-lg-7 offset-lg-1 order-lg-1">
			<div v-if="this.content.content" v-html="this.content.content.ru" />
			<div class="tag-button-group">
				<nuxt-link
					:to="$url.mediaList({ content_type: fetchedData.content_type })"
					class="btn btn-secondary-outer"
				>
					{{ contentTypeMap[fetchedData.content_type] }}
				</nuxt-link>
				<nuxt-link
					v-for="author in fetchedData.authors"
					v-if="fetchedData.authors !==null"
					:key="author.id"
					:to="$url.mediaList({ author: author.slug })"
					class="btn btn-secondary-outer"
				>
					{{ author.title }}
				</nuxt-link>
				<a
					v-if="fetchedData.issue !==null"
					:href="'/sp/anti-fragility/'"
					class="btn btn-secondary-outer"
					v-html="fetchedData.issue.title"
				/>
				<a
					v-if="fetchedData.content_source !==null"
					:href="'/sp/anti-fragility/article/?source='+fetchedData.content_source.title"
					class="btn btn-secondary-outer"
				>{{ fetchedData.content_source.url_title }}</a>

				<nuxt-link
					v-for="topic in fetchedData.taxonomy.topics"
					:key="topic.id"
					:to="`/media/?taxonomy_topic=${topic.id}`"
					class="btn btn-secondary-outer"
				>
					{{ topic.title }}
				</nuxt-link>
			</div>
		</div>
		<div class="col-12 col-lg-2">
			<div
				v-if="fetchedData.content_type === 2 || fetchedData.content_type === 0 "
				class="content-info"
			>
				<div class="share">
					<social-sharing inline-template>
						<div class="share_list">
							<network network="facebook">
								<i class="icon-fb" />
							</network>
							<network network="vk">
								<i class="icon-vk" />
							</network>
							<network network="twitter">
								<i class="icon-twitter" />
							</network>
							<network network="telegram">
								<i class="icon-telegram" />
							</network>
							<!-- <network network="whatsapp"><i class="fa fa-whatsapp"></i> Whatsapp</network> -->
						</div>
					</social-sharing>
					<hr>
				</div>
				<div v-if="fetchedData.content_type === 0">
					<div class="author_data">
						<div v-if="fetchedData.authors !==null && fetchedData.authors.length ===1">
							<div v-for="(author, index) in fetchedData.authors">
								<div class="author_title">
									{{ $t('author') }}
									<span class="author_text">{{ author.title }}</span>
								</div>
							</div>
						</div>
						<div v-if="fetchedData.authors.length !==1">
							<div class="author_title">
								{{ $t('authors') }}
								<span
									v-for="(author, index) in fetchedData.authors"
									:key="index"
									class="author_text"
								>
									{{ author.title }}
								</span>
							</div>
						</div>
						<div v-if="fetchedData.content_source !==null" class="author_title">
							{{ $t('contentSource') }}
							<span class="author_text">
								<a
									:href="fetchedData.content_source.url"
									target="_blank"
									rel="nofollow noopener noreferrer"
								>{{ fetchedData.content_source.url_title }}</a>
							</span>
						</div>
						<!-- <div class="author_title" v-if="fetchedData.photo_sources !== null">
              Фото <span class="author_text">{{fetchedData.photo_sources}}</span>
						</div>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ContentFooter',
	props: ['content', 'static_content', 'block_title', 'fetchedData'],
	data() {
		return {
			contentTypeMap: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
			},
			contentIconMap: {
				0: 'icon-text',
				1: 'icon-video',
				2: 'icon-audio',
			},
		};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/layouts/article-detail";

// .footer-block {
// 	.content-info {
// 		@include media-breakpoint-up(lg) {
// 			display: flex;
// 			height: 100%;
// 			flex-direction: column;
// 			justify-content: flex-end;

// 			.author_data {
// 				margin-bottom: 0.5rem;
// 			}
// 		}
// 	}
// }
</style>
